<searchbox-bar-v2 product="transferspoi" flow="search" context="search" [searchboxModel]="searchboxModel"
  [locale]="locale">
  <li class="re-search-item">
    <span class="item-container">
      <i class="eva-3-icon-location re-search-item-icon"></i>
      <span class="origin">{{sboxDisplay.from}}</span>
      <span *ngIf="travel">|</span>
      <span *ngIf="travel" class="destination">{{sboxDisplay.to}}</span>
    </span>
  </li>
  <li class="re-search-item">
    <span class="item-container">
      <i class="eva-3-icon-calendar re-search-item-icon"></i>
      <span class="item-date-container">{{sboxDisplay.fromDate}}
        <span class="-eva-3-hide-medium-down">{{sboxDisplay.fromYear}}
          <span class="-eva-3-hide-small">{{sboxDisplay.fromTime}}</span>
        </span>
      </span>
      <span *ngIf="isRoundtrip" class="item-date-container"> - {{sboxDisplay.toDate}}
        <span class="-eva-3-hide-medium-down">{{sboxDisplay.toYear}}
          <span class="-eva-3-hide-small">{{sboxDisplay.toTime}}</span>
        </span>
      </span>
    </span>
  </li>
  <li class="re-search-item">
    <span class="item-container">
      <i class="eva-3-icon-user re-search-item-icon"></i>{{sboxDisplay.passengerQty}}
    </span>
  </li>
</searchbox-bar-v2>